import * as React from 'react';

import BaseDialog, { BaseDialogProps } from '../Base';
import { BlockedUsersList } from './components/BlockedUsersList';

export const ListBlockedUsersDialog: React.FC<BaseDialogProps> = (props) => {
  return (
    <BaseDialog
      {...props}
      height='550px'
      sx={{
        '.MuiDialogContent-root': {
          p: 0,
        },
      }}
    >
      <BlockedUsersList />
    </BaseDialog>
  );
};
